import _ from 'lodash';
import { useApiFetchGetRequest } from 'react-scale/hooks/useApiFetchGetRequest';
import { CorpPreviewAssignmentJson } from '@scale/shared/assignmentJson/types/CorpPreviewAssignmentJson';
import { ConfigJson, twoDTypes } from '@scale/shared/defaults';
import { TaskType } from '@scale/shared-types';
import { useCommonFeatureFlags } from './useCommonFeatureFlags';

const useSupplementedTaskPreviewAssignment = (
  assignmentJson?: CorpPreviewAssignmentJson,
): CorpPreviewAssignmentJson | undefined => {
  const commonFeatureFlags = useCommonFeatureFlags(assignmentJson);

  const canSeeInlineComments = true;
  const canLeaveInlineComments = false;
  const canRejectWithChanges = false;
  const canAccessMinimap = false;

  const canUseGuidedWorkflow = false;
  const canUseGuidedWorkflowBar = false;
  const useReviewedAnnotationCheckmark = false;

  const featureFlags = {
    ...assignmentJson?.featureFlags,
    ...commonFeatureFlags,
    // Override some of the commonFeatureFlags with corp lookup hard codings
    canSeeInlineComments,
    canLeaveInlineComments,
    canRejectWithChanges,
    canAccessMinimap,
    canUseGuidedWorkflow,
    canUseGuidedWorkflowBar,
    useReviewedAnnotationCheckmark,
  };

  const shortCircuit =
    !_.includes(twoDTypes, assignmentJson?.type) &&
    assignmentJson?.type !== TaskType.DocumentTranscription &&
    assignmentJson?.type !== TaskType.TextCollection &&
    assignmentJson?.type !== TaskType.Chat &&
    assignmentJson?.type !== TaskType.ChatExperimental &&
    assignmentJson?.type !== TaskType.ChatV2;

  const projectConfig = useApiFetchGetRequest<ConfigJson>(
    `internal/config/${assignmentJson?.projectId}`,
    { shouldShortCircuit: shortCircuit },
  );

  if (!assignmentJson) return undefined;

  return {
    ...assignmentJson,
    featureFlags,
    config: projectConfig.response,
    projectConfig: projectConfig.response,
  };
};

export default useSupplementedTaskPreviewAssignment;
